import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

/**
 * features-list — used on Parent Login. Sized to half the row so consumers
 * can place it inside their own layout grid; here we just render a vertical
 * stack like the original ParentLoginPage.
 */
function FeaturesList({ data, onChange }) {
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    onChange && onChange({ ...data, items: next });
  };
  return (
    <section className="py-12 bg-white">
      <div className="container-page">
        <div className="space-y-6 max-w-2xl">
          {items.map((f, i) => {
            const I = getIcon(f.icon);
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="flex gap-5 p-6 rounded-2xl hover:bg-olive-light/50 transition">
                  <div className="h-14 w-14 rounded-2xl bg-olive text-white flex items-center justify-center shrink-0"><I size={26} /></div>
                  <div>
                    <EditableText value={f.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-display text-xl text-olive-deep" />
                    <EditableText value={f.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="text-ink/70 mt-1 leading-relaxed" />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FeaturesList;
